import script from "./UploadedDateiView.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadedDateiView.vue?vue&type=script&setup=true&lang=js"

import "./UploadedDateiView.vue?vue&type=style&index=0&id=f7dd2fde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7dd2fde"]])

export default __exports__